// Provenance — field-level data origin tag.
// Per LLM_NATIVE_ARCHITECTURE.md §2.1.
//
// Why this exists:
//   In LLM-native products, data with different origins has different
//   render/persistence/error semantics. mcq.options (llm_generated, immutable
//   reference) ≠ essay.draft.content (human_input, mutable) ≠ essay.aiScore
//   (llm_evaluated, async + nullable). Mixing them in the same object level
//   without origin tags is the root of bugs like "essay model answer leaked
//   pre-submission" (Session 19V mock-exam fix history).
//
// Five categories (LLM_NATIVE §2.1):
//   - human_input        : user typed it (essay draft, edited mcq option, …)
//   - llm_generated      : AI produced as static content (mcq, flashcard, …)
//   - llm_evaluated      : AI produced from human_input (essay aiScore, …)
//   - derived            : computed from other fields (mastery score, …)
//   - reference          : static lookup (case title, …)
//
// Use:
//   - schema-level: schemas can carry a `provenance` discriminator on
//     wrapper types (see editable-item.ts).
//   - codegen / inspection: tools can iterate `provenance` to decide
//     persistence / serialization / UI render.
import { z } from 'zod';
export const ProvenanceSchema = z.enum([
    'human_input',
    'llm_generated',
    'llm_evaluated',
    'derived',
    'reference',
]);
//# sourceMappingURL=provenance.js.map